module.exports = __webpack_public_path__ + "static/media/Presentation-InRisk.1c6e0514.pdf";